import { lazy } from 'react';

import type { ComponentType, LazyExoticComponent } from 'react';

export function lazyNamed<T extends ComponentType<unknown>>(
  importFn: () => Promise<Record<string, unknown>>,
  exportName: string = 'default'
): LazyExoticComponent<T> {
  return lazy(async () => {
    const m = await importFn();
    return { default: m[exportName] as T };
  });
}
